import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead, packagesJsonLdScript, packagesFaqJsonLdScript } from "@/lib/seo";
import { PakkettenPage } from "@/pages/pakketten";

export const Route = createFileRoute("/$lang/packages")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "en";
    const t = i18n.getFixedT(lang, "seo");
    const head = pageHead({
      lang,
      pathWithoutLang: "/pakketten",
      title: t("pakketten.title"),
      description: t("pakketten.description"),
    });
    return { ...head, scripts: [packagesJsonLdScript(lang), packagesFaqJsonLdScript(lang)] };
  },
  component: PakkettenPage,
});
